import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Component, inject, ViewChild, DestroyRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';

import { UserSuggestions } from '../../../index';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { ButtonComponent, ModalAlertComponent } from '@shared/components';
import { UserSuggestionsService } from '../../../services/user-suggestions.service';

import { ToastAlertService } from '@core/services';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatCardModule } from '@angular/material/card';
import { SearchFieldComponent } from '@shared/components/search-field/search-field.component';
import { ToolbarComponent } from '@shared/components/toolbar/toolbar.component';
import { MatPaginatorIntl } from '@angular/material/paginator';

@Component({
  selector: 'app-user-suggestions',
  templateUrl: './user-suggestions.component.html',
  standalone: true,
  imports: [
    ToolbarComponent,
    SearchFieldComponent,
    MatCardModule,
    MatTableModule,
    MatSortModule,
    MatCheckboxModule,
    MatButtonModule,
    MatMenuModule,
    MatIconModule,
    MatPaginatorModule,
    ButtonComponent,
  ],
})
export class UserSuggestionsComponent {
  paginatorIntl: MatPaginatorIntl = new MatPaginatorIntl();
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  displayedColumns: string[] = [
    'suggestion',
    'read',
    'state',
    'worker',
    'catalog',
    'options',
  ];
  dataSource: MatTableDataSource<UserSuggestions>;
  fielInput!: string;
  private dialog = inject(MatDialog);
  private userSuggestionsService = inject(UserSuggestionsService);
  private destroyRef = inject(DestroyRef);

  private alertService = inject(ToastAlertService);
  constructor() {
    this.paginatorIntl = new MatPaginatorIntl();
    this.dataSource = new MatTableDataSource();
  }
  ngOnInit(): void {
    this.chargueUserSuggestions();
  }
  sendMail() {
    this.userSuggestionsService.sendMailSuggestions().subscribe({
      next: resp => {
        if (resp.code === 10000) {
          this.alertService.sucess('Correo enviado con éxito');
        } else {
          this.alertService.error(resp.detail);
        }
      },
      complete: () => {
        this.alertService.sucess('Correo enviado con éxito');
      },
    });
  }

  // private chargueWokplaceType() {
  //   this.workplaceTypeService.getWorkplaces().subscribe({
  //     next: (resp: any) => {
  //       if (resp.status == 'OK') {
  //         this.dataSource = new MatTableDataSource(resp.reply);
  //         this.dataSource.paginator = this.paginator;
  //         this.dataSource.sort = this.sort;
  //       }
  //     }
  //   })
  // }

  private chargueUserSuggestions() {
    this.userSuggestionsService
      .getUserSuggestions()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (resp: any) => {
          if (resp.code === 10000) {
            this.dataSource = new MatTableDataSource(resp.reply);
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
            if (this.paginator) {
              this.paginator._intl.itemsPerPageLabel = 'Registros por página';
              this.paginator._intl.nextPageLabel = 'Página siguiente ';
              this.paginator._intl.previousPageLabel = 'Página anterior';
              this.paginator._intl.firstPageLabel = 'Primera página';
              this.paginator._intl.lastPageLabel = 'Última página';
              // Configuración del texto de la última página
              this.paginator._intl.getRangeLabel = (
                page: number,
                pageSize: number,
                length: number
              ) => {
                if (length === 0 || pageSize === 0) {
                  return `0 de ${length}`;
                }
                length = Math.max(length, 0);
                const startIndex = page * pageSize;
                const endIndex =
                  startIndex < length
                    ? Math.min(startIndex + pageSize, length)
                    : startIndex + pageSize;
                return `${startIndex + 1} - ${endIndex} de ${length}`;
              };
            }
          } else {
            this.alertService.error(resp.detail);
          }
        },
      });
  }

  loadAlertChecked(action: UserSuggestions) {
    if (action.read === 0) {
      this.alertService.sucess('Sugerencia Leida');
    }
  }

  toggleReadUserSugestions(action: UserSuggestions) {
    console.log(action.idSuggestion);
    this.userSuggestionsService
      .toggleReadStatus(action.idSuggestion)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (resp: any) => {
          if (resp.code === 10000) {
            this.chargueUserSuggestions();
            this.loadAlertChecked(action);
          } else {
            this.alertService.error(resp.detail);
          }
        },
      });
  }

  modalDelete(action: UserSuggestions) {
    const dialogDelete = this.dialog.open(ModalAlertComponent, {
      data: action?.suggestion,
      disableClose: true,
    });
    dialogDelete
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((result: boolean) => {
        if (!result) return;
        this.userSuggestionsService
          .deleteUserSuggestions(action.idSuggestion)
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe({
            next: resp => {
              if (resp.code === 10000) {
                this.chargueUserSuggestions();
                this.alertService.sucess('Sugerencia eliminada');
              } else {
                this.alertService.error(resp.detail);
              }
            },
          });
      });
  }
}
